import { invert } from 'lodash-es';

export enum JobTitleEnum {
  AdministrativeStaff = 'administrative_staff',
  AnestheticAssistant = 'anesthetic_assistant',
  Apprenticeship = 'apprenticeship',
  AssistantElderlyCareNurse = 'assistant_elderly_care_nurse',
  AssistantNurse = 'assistant_nurse',
  AssistantRemedialCareNurse = 'assistant_remedial_care_nurse',
  CareerChangers = 'career_changers',
  Companion = 'companion',
  ElderlyCareNurse = 'elderly_care_nurse',
  FunctionalDiagnosticsAssistant = 'functional_diagnostics_assistant',
  HomeManager = 'home_manager',
  HygieneSpecialist = 'hygiene_specialist',
  Instructor = 'instructor',
  IntensiveCareTechnicalAssistance = 'intensive_care_technical_assistance',
  LaboratoryAssistant = 'laboratory_assistant',
  MedicalAssistance = 'medical_assistance',
  MedicalAssistant = 'medical_assistant',
  Midwife = 'midwife',
  Nurse = 'nurse',
  NursingDirector = 'nursing_director',
  NursingSpecialistGeriatric = 'nursing_specialist_geriatric',
  NursingSpecialistHealthCare = 'nursing_specialist_health_care',
  NursingSupervisor = 'nursing_supervisor',
  OccupationalTherapist = 'occupational_therapist',
  OperationAssistant = 'operation_assistant',
  Osteopath = 'osteopath',
  Others = 'others',
  Paramedic = 'paramedic',
  PediatricNurse = 'pediatric_nurse',
  PharmaceuticalAssistant = 'pharmaceutical_assistant',
  PhysicalTherapist = 'physical_therapist',
  PracticeManager = 'practice_manager',
  QualifiedDentalEmployee = 'qualified_dental_employee',
  QualityManagement = 'quality_management',
  RadiologyAssistant = 'radiology_assistant',
  RemedialCareNurse = 'remedial_care_nurse',
  ResidentialSectorManager = 'residential_sector_manager',
  SpeechTherapist = 'speech_therapist',
  SurgeryAssistant = 'surgery_assistant',
  ChemistAssistant = 'chemist_assistant',
  TeamLeader = 'team_leader',
  TechnicalAssistant = 'technical_assistant',
  UnitManager = 'unit_manager',
  ChiefPhysician = 'chief_physician',
  MedicalDirector = 'medical_director',
  SeniorPhysician = 'senior_physician',
  SpecialistPhysician = 'specialist_physician',
  ResidentPhysician = 'resident_physician',
  PracticeAcquisition = 'practice_acquisition',
  MedicalStudent = 'medical_student',
  Orthodontist = 'orthodontist',
  OralSurgeon = 'oral_surgeon',
  MkgSurgeon = 'mkg_surgeon',
  EmployedDentist = 'employed_dentist',
  DentalTrainingAssistant = 'dental_training_assistant',
  PediatricDentist = 'pediatric_dentist',
  DentalPrepAssistant = 'dental_prep_assistant',
}

export enum DeputyJobTitleEnum {
  DeputyHomeManager = 'deputy_home_manager',
  DeputyInstructor = 'deputy_instructor',
  DeputyNursingDirector = 'deputy_nursing_director',
  DeputyNursingSupervisor = 'deputy_nursing_supervisor',
  DeputyResidentialSectorManager = 'deputy_residential_sector_manager',
  DeputyTeamLeader = 'deputy_team_leader',
  DeputyUnitManager = 'deputy_unit_manager',
}

export const AUTOMATIC_MATCH_JOB_GROUPS = [
  [
    {
      title: JobTitleEnum.ElderlyCareNurse,
      deputy: false,
    },
    {
      title: JobTitleEnum.HomeManager,
      deputy: false,
    },
    {
      title: JobTitleEnum.Nurse,
      deputy: false,
    },
    {
      title: JobTitleEnum.HygieneSpecialist,
      deputy: false,
    },
    {
      title: JobTitleEnum.PediatricNurse,
      deputy: false,
    },
    {
      title: JobTitleEnum.NursingSupervisor,
      deputy: false,
    },
    {
      title: JobTitleEnum.NursingDirector,
      deputy: false,
    },
    {
      title: JobTitleEnum.NursingSpecialistHealthCare,
      deputy: false,
    },
    {
      title: JobTitleEnum.NursingSpecialistGeriatric,
      deputy: false,
    },
    {
      title: JobTitleEnum.Instructor,
      deputy: false,
    },
    {
      title: JobTitleEnum.QualityManagement,
      deputy: false,
    },
    {
      title: JobTitleEnum.UnitManager,
      deputy: false,
    },
    {
      title: JobTitleEnum.HomeManager,
      deputy: true,
    },
    {
      title: JobTitleEnum.NursingSupervisor,
      deputy: true,
    },
    {
      title: JobTitleEnum.NursingDirector,
      deputy: true,
    },
    {
      title: JobTitleEnum.Instructor,
      deputy: true,
    },
    {
      title: JobTitleEnum.UnitManager,
      deputy: true,
    },
    {
      title: JobTitleEnum.TeamLeader,
      deputy: true,
    },
    {
      title: JobTitleEnum.ResidentialSectorManager,
      deputy: true,
    },
    {
      title: JobTitleEnum.TeamLeader,
      deputy: false,
    },
    {
      title: JobTitleEnum.ResidentialSectorManager,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.AssistantElderlyCareNurse,
      deputy: false,
    },
    {
      title: JobTitleEnum.Companion,
      deputy: false,
    },
    {
      title: JobTitleEnum.AssistantNurse,
      deputy: false,
    },
    {
      title: JobTitleEnum.AssistantRemedialCareNurse,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.AnestheticAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.Apprenticeship,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.SurgeryAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.Midwife,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.RemedialCareNurse,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.IntensiveCareTechnicalAssistance,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.MedicalAssistance,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.MedicalAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.TechnicalAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.FunctionalDiagnosticsAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.LaboratoryAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.RadiologyAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.OperationAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.PracticeManager,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.PharmaceuticalAssistant,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.CareerChangers,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.Paramedic,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.AdministrativeStaff,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.QualifiedDentalEmployee,
      deputy: false,
    },
  ],
  [
    {
      title: JobTitleEnum.ChemistAssistant,
      deputy: false,
    },
  ],
];

export const INCOMPLETE_JOB_POSITIONS = [JobTitleEnum.TeamLeader, JobTitleEnum.HygieneSpecialist];

export const HELPING_JOB_POSITIONS = [
  JobTitleEnum.MedicalAssistance,
  JobTitleEnum.AssistantElderlyCareNurse,
  JobTitleEnum.AssistantNurse,
  JobTitleEnum.Companion,
  JobTitleEnum.AssistantRemedialCareNurse,
  JobTitleEnum.Apprenticeship,
  JobTitleEnum.CareerChangers,
];

export const PFLEGEFACHKRAFT_ROLE_GROUP = {
  slug: 'pflegefachkraft',
  label: 'Pflegefachkraft',
  jobTitles: [
    JobTitleEnum.Nurse,
    JobTitleEnum.ElderlyCareNurse,
    JobTitleEnum.NursingSpecialistGeriatric,
    JobTitleEnum.NursingSpecialistHealthCare,
  ],
};

export const OTHER_JOB_POSITIONS = [
  JobTitleEnum.Others,
  JobTitleEnum.QualityManagement,
  JobTitleEnum.UnitManager,
  JobTitleEnum.NursingSupervisor,
  JobTitleEnum.ResidentialSectorManager,
  JobTitleEnum.Instructor,
  JobTitleEnum.HomeManager,
  JobTitleEnum.NursingDirector,
  JobTitleEnum.HygieneSpecialist,
  JobTitleEnum.TeamLeader,
];

export const JOB_TITLES_TRANSLATIONS = {
  [JobTitleEnum.AdministrativeStaff]: 'Verwaltungspersonal',
  [JobTitleEnum.AnestheticAssistant]: 'ATA',
  [JobTitleEnum.Apprenticeship]: 'Auszubildender',
  [JobTitleEnum.AssistantElderlyCareNurse]: 'Altenpflegehelfer/in',
  [JobTitleEnum.AssistantNurse]: 'Gesundheits- und Krankenpflegehelfer/in',
  [JobTitleEnum.AssistantRemedialCareNurse]: 'Heilerziehungspflegehelfer/in',
  [JobTitleEnum.CareerChangers]: 'Quereinsteiger/in',
  [JobTitleEnum.Companion]: 'Betreuungskraft / Alltagsbegleiter/in',
  [JobTitleEnum.ElderlyCareNurse]: 'Altenpflegefachkraft',
  [JobTitleEnum.FunctionalDiagnosticsAssistant]: 'MTAF',
  [JobTitleEnum.HomeManager]: 'Einrichtungsleitung',
  [JobTitleEnum.HygieneSpecialist]: 'Hygienefachkraft',
  [JobTitleEnum.Instructor]: 'Praxisanleitung',
  [JobTitleEnum.IntensiveCareTechnicalAssistance]: 'ITA',
  [JobTitleEnum.LaboratoryAssistant]: 'MTLA',
  [JobTitleEnum.MedicalAssistance]: 'Medizinische Hilfskraft',
  [JobTitleEnum.MedicalAssistant]: 'Medizinische:r Fachangestellte:r',
  [JobTitleEnum.Midwife]: 'Hebamme',
  [JobTitleEnum.Nurse]: 'Gesundheits- und Krankenpfleger/in',
  [JobTitleEnum.NursingDirector]: 'Pflegedirektion',
  [JobTitleEnum.NursingSpecialistGeriatric]: 'Pflegefachfrau/Pflegefachmann (Vertiefung Altenpflege)',
  [JobTitleEnum.NursingSpecialistHealthCare]: 'Pflegefachfrau/Pflegefachmann (Vertiefung Akutpflege)',
  [JobTitleEnum.NursingSupervisor]: 'Pflegedienstleitung',
  [JobTitleEnum.OccupationalTherapist]: 'Ergotherapeut',
  [JobTitleEnum.OperationAssistant]: 'Operationsassistent',
  [JobTitleEnum.Osteopath]: 'Osteopathen',
  [JobTitleEnum.Others]: 'Sonstiges',
  [JobTitleEnum.Paramedic]: 'Sanitäter/in',
  [JobTitleEnum.PediatricNurse]: 'Kinderkrankenpfleger/in',
  [JobTitleEnum.PharmaceuticalAssistant]: 'Pharmazeutischer Assistent',
  [JobTitleEnum.PhysicalTherapist]: 'Physiotherapeut',
  [JobTitleEnum.PracticeManager]: 'Praxismanager',
  [JobTitleEnum.QualifiedDentalEmployee]: 'ZFA',
  [JobTitleEnum.QualityManagement]: 'Qualitätsmanagement',
  [JobTitleEnum.RadiologyAssistant]: 'Assistenz in der Radiologie',
  [JobTitleEnum.RemedialCareNurse]: 'Heilerziehungspfleger/in',
  [JobTitleEnum.ResidentialSectorManager]: 'Wohnbereichsleitung',
  [JobTitleEnum.SpeechTherapist]: 'Logopäden',
  [JobTitleEnum.SurgeryAssistant]: 'Assistenz in der Chirurgie',
  [JobTitleEnum.ChemistAssistant]: 'Chemisch Assistent',
  [JobTitleEnum.TeamLeader]: 'Teamleiter/in',
  [JobTitleEnum.TechnicalAssistant]: 'Medizinisch-technische Assistenz',
  [JobTitleEnum.UnitManager]: 'Stationsleitung',
  [JobTitleEnum.ChiefPhysician]: 'Chefarzt',
  [JobTitleEnum.MedicalDirector]: 'Ärztlicher Direktor',
  [JobTitleEnum.SeniorPhysician]: 'Oberarzt',
  [JobTitleEnum.SpecialistPhysician]: 'Facharzt',
  [JobTitleEnum.ResidentPhysician]: 'Assistenzarzt',
  [JobTitleEnum.PracticeAcquisition]: 'Praxisübernahme',
  [JobTitleEnum.MedicalStudent]: 'Famulatur / PJ',
  [JobTitleEnum.Orthodontist]: 'Kieferorthopäde',
  [JobTitleEnum.OralSurgeon]: 'Oralchirurg',
  [JobTitleEnum.MkgSurgeon]: 'MKG-Chirurg',
  [JobTitleEnum.EmployedDentist]: 'Zahnarzt',
  [JobTitleEnum.DentalTrainingAssistant]: 'Vorbereitungsassistent',
  [JobTitleEnum.PediatricDentist]: 'Kinderzahnarzt',
  [JobTitleEnum.DentalPrepAssistant]: 'Zahnarzt i.V.',
  deputy: 'Stellvertretende',
  visceralMedicine: 'Viszeralmedizin',
};

export const REVERSED_JOB_TITLES_TRANSLATIONS = invert(JOB_TITLES_TRANSLATIONS);

export const PRAXIA_SEO_JOB_TITLES = [
  JobTitleEnum.MedicalAssistant,
  JobTitleEnum.QualifiedDentalEmployee,
  JobTitleEnum.RadiologyAssistant,
  JobTitleEnum.LaboratoryAssistant,
  JobTitleEnum.FunctionalDiagnosticsAssistant,
  JobTitleEnum.SpeechTherapist,
  JobTitleEnum.OccupationalTherapist,
  JobTitleEnum.Osteopath,
  JobTitleEnum.PhysicalTherapist,
  JobTitleEnum.PracticeManager,
];

export const COMMON_DOWNGRADES = {
  Nursing: {
    CareTakers: [JobTitleEnum.Nurse, JobTitleEnum.ElderlyCareNurse], // GuK + APK
    Assistants: [JobTitleEnum.AssistantNurse, JobTitleEnum.AssistantElderlyCareNurse], // GuKh + APKh
  },
  Medical: {
    Assistants: [JobTitleEnum.MedicalAssistance, JobTitleEnum.QualifiedDentalEmployee], // MFA + ZFA
  },
};
